import { Button, Loader } from '@mantine/core';
import { useMemo } from 'react';
import { api } from '~/trpc-extra/api';

const DISPLAY_LIMIT = 5;
export default function QuickViewIssueTestRuns({ issueId }: { issueId: string }) {
  const { data: issue, isLoading } = api.issues.get.useQuery({ issueId });

  const truncatedTestRuns = useMemo(() => {
    if (isLoading) {
      return [];
    }
    if (!issue) {
      return [];
    }

    if (issue.TestRunAttempts.length <= DISPLAY_LIMIT) {
      return issue.TestRunAttempts.map((x) => x.testRun);
    }
    return issue.TestRunAttempts.map((x) => x.testRun).slice(0, 5);
  }, [issue, isLoading]);

  return isLoading ?
      <div>
        <Loader />
      </div>
    : <div>
        <ul>
          {truncatedTestRuns.map((run) => (
            <li
              className="pb-2 text-xs"
              key={run.id}
            >
              <div
                className="font-medium text-gray-600 underline hover:cursor-pointer dark:text-gray-400"
                onClick={() => {
                  // TODO: this url is wrong
                  window.open(`/project/${run.testV2.projectId}/history/s_${run.testV2.id}/run/${run.id}`, '_blank');
                }}
              >
                Run #{run.id.slice(0, 8)}
              </div>
              <div>{run.testV2.name}</div>
            </li>
          ))}
        </ul>
        {(issue?.TestRunAttempts.length || 0) > DISPLAY_LIMIT && (
          <Button
            size="xs"
            variant="light"
            onClick={() => window.open(`/project/${issue?.projectId}/issues/${issueId}`, '_blank')}
          >
            View All
          </Button>
        )}
      </div>;
}
